<template #append>
    <v-menu :close-on-content-click="false" :nudge-width="200" offset-x location="start">
        <template v-slot:activator="{ props }">
            <v-tooltip location="bottom">
                <template v-slot:activator="{ props: propsTooltip }">
                    <div v-bind="propsTooltip">
                        <v-badge dot v-model="showUpgradeUI" floating>
                            <v-avatar
                                :color="avatarColor"
                                v-bind="props"
                                density="comfortable"
                                :style="topButtonStyle"
                                data-cy="profileMenu-showUserProfile"
                            >
                                {{ getUserBigram(currentUser) }}
                            </v-avatar>
                        </v-badge>
                    </div>
                </template>
                <span>{{ avatarTitle }}</span>
            </v-tooltip>
        </template>
        <div class="ma-2">
            <v-card class="rounded-lg" elevation="1">
                <v-list class="mb-n2">
                    <v-list-item>
                        <template #prepend>
                            <v-avatar color="#EAEAEA" small size="36">
                                <span class="primary--text text-h6 font-weight-bold">{{
                                    getUserBigram(currentUser)
                                }}</span>
                            </v-avatar>
                        </template>
                        <v-list-item-title class="d-flex">
                            <span>{{ getUserDisplayName(currentUser) }}</span>
                            <v-spacer />
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                            currentUser?.company?.name || ""
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{
                            getDisplayEmail(currentUser?.email)
                        }}</v-list-item-subtitle>
                        <template #append>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <v-chip
                                            x-small
                                            dark
                                            label
                                            @click="onClickProfileRulesDialog()"
                                            color="primary"
                                            variant="outlined"
                                            >{{ avatarTitle }}</v-chip
                                        >
                                    </div>
                                </template>
                                <span>Voir les droits du profil</span>
                            </v-tooltip>
                        </template>
                    </v-list-item>
                </v-list>

                <v-divider class="mx-4" />

                <v-list>
                    <v-list-item ripple @click="openProfileDialog" v-if="!isInInternalManagement">
                        <v-list-item-title class="d-flex align-center">
                            Voir la page en tant que
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-user-cog" />
                        </template>
                    </v-list-item>
                    <v-list-item ripple v-if="showUpgradeUI" @click="upgradeUi()">
                        <v-list-item-title
                            class="text-decoration-underline"
                            style="cursor: pointer"
                        >
                            Mettre à jour bobbee maintenant
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item ripple v-if="showInstallPWA" @click="installPWA()">
                        <v-list-item-title class="d-flex align-center">
                            Installer bobbee
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-download" />
                        </template>
                    </v-list-item>
                    <v-list-item @click="activateUserWorkingTime = true" v-if="isAccountingUser">
                        <v-list-item-title class="d-flex align-center">
                            Suivi des temps
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-business-time" />
                        </template>
                    </v-list-item>
                    <v-list-item @click="passwordChange = true">
                        <v-list-item-title class="d-flex align-center">
                            Changer de mot de passe
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-lock" />
                        </template>
                    </v-list-item>
                    <v-list-item @click="activateVersionsDialog = true">
                        <v-list-item-title class="d-flex align-center">
                            Les mises à jour
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-redo" />
                        </template>
                    </v-list-item>
                    <v-list-item @click="onKnowledgeBaseClicked">
                        <v-list-item-title class="d-flex align-center">
                            La base de connaissance
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-atlas">$fa-atlas</v-icon>
                        </template>
                    </v-list-item>
                    <v-list-item @click="openTutorialsDialog(null)">
                        <v-list-item-title class="d-flex align-center">
                            Les tutoriels &#xab; pas à pas &#xbb;
                        </v-list-item-title>
                        <template #append>
                            <v-icon size="small" icon="$fa-shoe-prints" />
                        </template>
                    </v-list-item>
                </v-list>
            </v-card>
            <v-btn-primary
                block
                @click="logout"
                data-cy="profileMenu-logout"
                size="large"
                class="error mt-2"
                elevation="1"
                >Se déconnecter</v-btn-primary
            >
        </div>

        <oss-dialog title="Droits du profil" v-model="showProfileRulesDialog" min-width="70vw">
            <div width="70vw">
                <profile :profileId="profileId" :isConsultation="true" />
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="passwordChange"
            :persistent="firstLoginDialog"
            title="Changer votre mot de passe"
            validText="Modifier"
            @valid="changePassword"
            width="40vw"
        >
            <v-form ref="form">
                <v-row no-gutters class="py-1">
                    <v-col cols="12" v-if="firstLoginDialog" class="pb-2">
                        Afin de garantir la sécurité de votre compte, merci de créer une nouveau mot
                        de passe
                    </v-col>
                    <v-col cols="12">
                        <v-text-field-filled
                            required
                            :type="showPasswordPrevious ? 'text' : 'password'"
                            :append-inner-icon="
                                showPasswordPrevious ? '$oss-eye' : '$oss-eye-slash'
                            "
                            :rules="[() => previousPassword.length > 0 || 'empty password']"
                            @keyup.enter="changePassword"
                            label="Mot de passe actuel"
                            v-model="previousPassword"
                            density="compact"
                            @click:append-inner="showPasswordPrevious = !showPasswordPrevious"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field-filled
                            required
                            :type="showPassword ? 'text' : 'password'"
                            :append-inner:icon="showPassword ? '$oss-eye' : '$oss-eye-slash'"
                            :rules="[
                                () => password.length > 0 || 'empty password',
                                () =>
                                    password === pwdConfirmation ||
                                    !(pwdConfirmation.length > 0) ||
                                    'Passwords does not match',
                            ]"
                            @keyup.enter="changePassword"
                            label="Nouveau mot de passe"
                            v-model="password"
                            density="compact"
                            @click:append-inner="showPassword = !showPassword"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field-filled
                            required
                            type="password"
                            :rules="[
                                () => pwdConfirmation.length > 0 || 'empty password',
                                () =>
                                    password === pwdConfirmation ||
                                    !(password.length > 0) ||
                                    'Passwords does not match',
                            ]"
                            @keyup.enter="changePassword"
                            label="Confirmer votre mot de passe"
                            v-model="pwdConfirmation"
                        />
                    </v-col>
                </v-row>
            </v-form>
            <v-alert type="success" :value="isPasswordModified">
                Votre mot de passe a bien été modifié
                <br />
                <router-link :to="'/login'">Se connecter</router-link>
            </v-alert>
        </oss-dialog>
        <WorkingTime v-model="activateUserWorkingTime" v-if="activateUserWorkingTime" />
        <oss-dialog
            @keydown.esc="activateHelp = false"
            @previous="tutorialBack()"
            title="Tutoriels"
            v-model="activateHelp"
            :max-width="$vuetify.display.mobile ? 'auto' : '70vw'"
            v-if="!emailVerification && !isAuth()"
        >
            <tutorials ref="tutorialWizard" v-if="activateHelp" :tutorials="tutorials" />
        </oss-dialog>

        <oss-dialog
            @keydown.esc="activateHelp = false"
            title="Les mises à jour"
            v-model="activateVersionsDialog"
            :max-width="$vuetify.display.mobile ? 'auto' : '70vw'"
            v-if="!emailVerification && !isAuth()"
        >
            <div style="height: 60vh; width: 100vw">
                <iframe
                    style="height: 60vh; width: 100vw"
                    frameBorder="0"
                    :src="versionsEmbededPath"
                />
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="activateProfileDialog"
            title="Voir la page en tant que"
            validText="Changer"
            @valid="changeProfile"
            width="40vw"
        >
            <v-row no-gutters class="mb-1">
                <v-col cols="10" class="pr-1">
                    <v-select-filled
                        v-model="profileId"
                        :items="availableProfiles"
                        :item-title="getProfileName"
                        item-value="id"
                        label="Profil utilisateur"
                        outlined
                        dense
                        hide-details="auto"
                        v-if="availableProfiles && availableProfiles.length"
                    />
                </v-col>
                <v-col cols="2" class="pb-2">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon icon="$fa-redo" @click="resetProfile" v-bind="props" />
                        </template>
                        <span>Réinitialiser</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </oss-dialog>
    </v-menu>
</template>

<script lang="ts">
import { getUserBigram, getUserDisplayName, logOutUser } from "../../services/userServices";
import { User } from "../../store/store";

import WorkingTime from "../user/UserWorkingTime.vue";

import { Apollo } from "@/decorators";

import { AuthServices } from "@/services/auth.services";
import { getDisplayEmail } from "@/services/emailServices";

import UPDATE_USER_PASSWORD from "@/graphql/user/UpdateUserPassword.gql";
import REFERENCE_PROFILES from "@/graphql/profiles/ReferenceProfiles.gql";
import GET_ALL_TUTORIALS from "@/graphql/tutorials/GetAllTutorials.gql";
import CHANGE_USER_PROFILE from "@/graphql/user/ChangeUserProfile.gql";
import TutorialsComp, { TutorialsList } from "@/views/tutorial/TutorialsList.vue";
import getEnv from "@/env";
import { getProfileName } from "../../services/profile";
import { updateStoreUser } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";
import Profile from "../admin/Profile.vue";

const env = getEnv();

const VERSIONS_TUTORIAL_PATH = "9999 - Contenu des versions";

const VERSIONS_EMBEDED_URL_PATH =
    "https://docs.google.com/document/d/e/2PACX-1vSKoiRAYU32aZIsKnO4_-MIop88z3kXxYVZznhqekIghK5Jxz8fX20M0-IQnmp_drM2SP-GfDVzMPkd/pub?embedded=true";

@Component({
    components: {
        Profile,
        WorkingTime,
        Tutorials: TutorialsComp,
    },
})
export class ProfileMenu extends Vue {
    passwordChange = false;
    password = "";
    pwdConfirmation = "";
    previousPassword = "";
    profileId: string = "";
    activateProfileDialog = false;

    showPassword = false;
    showPasswordPrevious = false;

    firstLoginDialog = false;

    isPasswordModified = false;

    loading = false;

    showUpgradeUI = false;

    showInstallPWA = false;

    activateUserWorkingTime = false;

    activateHelp = false;
    @Ref("tutorialWizard") tutorialWizard!: TutorialsList;
    /**
     * Opens the profile rules dialog when turned to true
     */
    showProfileRulesDialog = false;

    activateVersionsDialog = false;

    localEnv = env.environnement;

    get topButtonStyle() {
        let style = "pointer-events:auto; margin-right: 3px;";
        if (!this.$vuetify.display.mobile) {
            style += " color: #000;";
        }
        return style;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser?.isAccountingUser;
    }

    get avatarColor() {
        if (this.currentUser) {
            if (this.currentUser.isRoot) {
                return "error";
            }
            if (this.currentUser.profile?.type === "ACCOUNTING") {
                return "secondary";
            }
        }
        return "primary";
    }

    get avatarTitle() {
        if (this.currentUser?.profile?.displayName) {
            return this.currentUser?.profile?.displayName;
        }
        if (this.currentUser?.profile?.name) {
            return this.$t("profiles.name." + this.currentUser?.profile?.name);
        }
        return "XXX";
        // if (this.currentUser.isRoot) {
        //     return this.$t('root')
        // }
        // if (this.currentUser.profile.type === "ACCOUNTING") {
        //     return this.$t('cabinet')
        // }
        // return this.$t('cl')
    }

    get isInInternalManagement() {
        return this.$route.path.includes("admin");
    }

    async logout() {
        if (
            this.$store.state.user.profile &&
            this.$store.state.user.profile.id &&
            this.$store.state.user.switchOriginalProfile &&
            this.$store.state.user.switchOriginalProfile.id &&
            this.$store.state.user.profile.id !== this.$store.state.user.switchOriginalProfile.id
        ) {
            await this.resetProfile();
        }
        // await this.$store.commit("logoutUser");
        logOutUser(this.$store, this.$router);
    }

    beforeMount() {
        if (this.$store.state.user.firstLogin) {
            this.passwordChange = true;
            this.firstLoginDialog = true;
        }
        // @ts-ignore
        // if (this.$workbox) {
        //     // @ts-ignore
        //     this.$workbox.addEventListener("waiting", () => {
        //         this.showUpgradeUI = true
        //     });
        // }

        window.addEventListener("beforeinstallprompt", (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e;
            // Update UI notify the user they can install the PWA
            this.showInstallPromotion();
            // Optionally, send analytics event that PWA install promo was shown.
            console.log(`'beforeinstallprompt' event was fired.`);
        });
    }

    @Apollo({
        query: REFERENCE_PROFILES,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser?.id || !this.currentUser?.company?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.profiles) {
                    data.profiles.sort((a, b) => {
                        if (this.$t("profiles.name." + a.name) < this.$t("profiles.name." + b.name))
                            return -1;
                        if (this.$t("profiles.name." + a.name) > this.$t("profiles.name." + b.name))
                            return 1;
                        return 0;
                    });

                    this.availableProfiles = data.profiles;
                }
            }
        },
    })
    availableProfiles: any = [];

    @Apollo({
        query() {
            return GET_ALL_TUTORIALS;
        },
        variables() {
            return {};
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.learningObjects) {
                    this.tutorials = data.learningObjects;
                } else {
                    this.tutorials = [];
                }
            }
        },
    })
    tutorials: any = [];

    resetChangePassword() {
        this.password = "";
        this.pwdConfirmation = "";
        this.passwordChange = false;
        if (this.firstLoginDialog) {
            this.firstLoginDialog = false;
        }
    }

    getDisplayEmail(email) {
        return getDisplayEmail(email);
    }

    deferredPrompt = null;

    // upgradeUi() {
    //     window.addEventListener('beforeinstallprompt', (e) => {
    //         // Prevent the mini-infobar from appearing on mobile
    //         e.preventDefault();
    //         // Stash the event so it can be triggered later.
    //         this.deferredPrompt = e;
    //         // Update UI notify the user they can install the PWA
    //         this.showInstallPromotion();
    //         // Optionally, send analytics event that PWA install promo was shown.
    //         console.log(`'beforeinstallprompt' event was fired.`);
    //     });
    // }

    showInstallPromotion() {
        this.showInstallPWA = true;
    }

    getUserBigram(user) {
        return getUserBigram(user);
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    async installPWA() {
        this.showUpgradeUI = false;
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        this.deferredPrompt = null;
    }

    async changePassword() {
        // @ts-ignore
        if (!this.$refs.form.validate()) return;
        this.loading = true;
        await AuthServices.changePassword(
            this.previousPassword,
            this.password,
            this.currentUser.id,
        );

        this.loading = false;
        this.resetChangePassword();
    }

    onKnowledgeBaseClicked() {
        window.open("https://knowledge.bobbee.co/", "_blank");
    }

    openTutorialsDialog(initialPath = null) {
        this.activateHelp = true;
    }

    tutorialBack() {
        this.tutorialWizard.goBack();
    }

    get emailVerification() {
        if (!env.ENABLE_COGNITO) return false;
        if (!this.currentUser || !this.currentUser.id) return false;
        if (!this.currentUser.emailVerified /*&& !this.alreadyAskedEmailVerification*/) {
            return true;
        }
        return false;
    }

    get env() {
        return env;
    }

    isAuth() {
        const name = this.$route.name;
        if (
            name === "login" ||
            name === "signup" ||
            name === "password-recovery" ||
            name === "password-reset" ||
            name === "email-verification" ||
            name === "maintenance"
        ) {
            return true;
        }
        return false;
    }

    get versionsPath() {
        return VERSIONS_TUTORIAL_PATH;
    }

    get versionsEmbededPath() {
        return VERSIONS_EMBEDED_URL_PATH;
    }

    /**
     * Opens/Close dialog on click
     */
    onClickProfileRulesDialog() {
        this.profileId = this.$store.state.user.profile.id;
        this.showProfileRulesDialog = !this.showProfileRulesDialog;
    }

    openProfileDialog() {
        this.profileId = this.$store.state.user.profile.id;
        this.activateProfileDialog = true;
    }

    getProfileName(profile) {
        if (profile) {
            return getProfileName(this, profile);
        }
        return "XXXX";
    }

    async changeProfile() {
        const selectedProfile = this.availableProfiles.find(
            (profile) => profile.id === this.profileId,
        );
        if (
            selectedProfile &&
            selectedProfile.id &&
            selectedProfile.id !== this.$store.state.user.profile.id
        ) {
            try {
                const result = await this.$apollo.mutate({
                    mutation: CHANGE_USER_PROFILE,
                    variables: {
                        profileId: selectedProfile.id ? selectedProfile.id : "",
                    },
                });

                if (result.data?.changeUserProfile?.success) {
                    // if (result.data?.changeUserProfile?.user?.profile) {
                    // await this.$store.dispatch('changeProfile', result.data?.changeUserProfile?.user?.profile);
                    updateStoreUser(this.$apollo, this.$store, this.$store.state.user.id);
                    this.profileId = this.$store.state.user.profile.id;
                    this.activateProfileDialog = false;

                    await this.refresh();
                    // }
                } else {
                    console.error("Erreur lors du changement de profil :", result);
                }
            } catch (error) {
                console.error("Erreur lors du changement de profil :", error);
            }
            // this.activateProfileDialog = false;
        }
    }

    async resetProfile() {
        if (
            this.$store.state.user.profile &&
            this.$store.state.user.profile.id &&
            this.$store.state.user.switchOriginalProfile &&
            this.$store.state.user.switchOriginalProfile.id &&
            this.$store.state.user.profile.id !== this.$store.state.user.switchOriginalProfile.id
        ) {
            try {
                const result = await this.$apollo.mutate({
                    mutation: CHANGE_USER_PROFILE,
                    variables: {
                        profileId: null,
                    },
                });

                if (result.data?.changeUserProfile?.success) {
                    debugger;
                    // if (result.data?.changeUserProfile?.user?.profile) {
                    // await this.$store.dispatch('changeProfile', result.data?.changeUserProfile?.user?.profile);
                    updateStoreUser(this.$apollo, this.$store, this.$store.state.user.id);
                    this.profileId = this.$store.state.user.profile.id;
                    this.activateProfileDialog = false;
                    // }
                    await this.refresh();
                } else {
                    console.error("Erreur lors du changement de profil :", result);
                }
            } catch (error) {
                console.error("Erreur lors du changement de profil :", error);
            }
        }
    }

    async refresh() {
        /**
         * Reload the page to refresh the user profile
         * Since the user profile is stored in the store, we need to reload the page to refresh the user profile
         */
        window.location.reload();
    }
}

export default toNative(ProfileMenu);
</script>
